import { setAuthTokens } from "@serophin/browser";
import { clearClientCache } from "@serophin/nottldr-shared";
import type { SignInResult } from "@serophin/shared";
import { safeNextPath } from "@serophin/shared";
import { refreshSession } from "../../platform/session";

/*
 * Client ids reach the browser bundle through Vite `define` (vite.config.ts reads GOOGLE_WEB_CLIENT_ID and
 * APPLE_SERVICES_ID from nottldr/.env). An empty value hides that provider's button; email sign-in always works.
 */
declare const __GOOGLE_WEB_CLIENT_ID__: string | undefined;
declare const __APPLE_SERVICES_ID__: string | undefined;

export const GOOGLE_WEB_CLIENT_ID: string = typeof __GOOGLE_WEB_CLIENT_ID__ === "string" ? __GOOGLE_WEB_CLIENT_ID__ : "";
export const APPLE_SERVICES_ID: string = typeof __APPLE_SERVICES_ID__ === "string" ? __APPLE_SERVICES_ID__ : "";

/** The page the framework's Google and Apple flows send the browser back to. Client side only. */
export const originPath = (path: string): string => (typeof window === "undefined" ? path : `${window.location.origin}${path}`);

/** Where to go after sign-in: the `redirect` (or `next`) of the page's own query string, else the feed or landing page at `/`. */
export const targetAfterSignIn = (next?: string): string => {
  const params = new URLSearchParams(window.location.search);
  return safeNextPath(next) ?? safeNextPath(params.get("redirect")) ?? safeNextPath(params.get("next")) ?? "/";
};

/** Stores the token pair, tells the site about the session and leaves for the page the visitor wanted. */
export const finishSignIn = (provider: string, result: SignInResult, next?: string): void => {
  // Whatever the browser cached belongs to the previous visitor or user, never to this one.
  clearClientCache();
  setAuthTokens(result);
  refreshSession();
  window.location.assign(targetAfterSignIn(next));
};
